// Payments — ADMIN (operations) workspace page.
// Check every won deal's payment, approve it, and collect open balances —
// the checkpoint between counter sales and dispatch.

import React from 'react';
import OpsLayout from '../../components/layout/OpsLayout.jsx';
import PaymentsBoard from '../../components/ops/PaymentsBoard.jsx';
import { opsDispatchApi, opsCounterApi } from '../../api/opsApi';

const OpsPaymentsPage = () => (
  <OpsLayout>
    <PaymentsBoard api={opsDispatchApi} counterApi={opsCounterApi} />
  </OpsLayout>
);

export default OpsPaymentsPage;
